
const ChatBot = () => {
    return (
        <div style={{ zIndex: 999 }} className='fixed bottom-8 left-12 w-fit'>
            <button
                onClick={() => {
                    try {
                        setTimeout(() => window.$irfchat?.toggle(), 0)
                    } catch (e) {
                        //
                    }
                }}
                type='button'
                className='flex-justify-center size-48'
            >
                <img width={56} height={56} alt='chat' src='/assets/images/chat.webp' />
            </button>
        </div>
    );
};

export default ChatBot;